import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = createClient({
  projectId: "uvmw3p16",
  dataset: "production",
  apiVersion: "2024-03-14",
  useCdn: true,
  token: process.env.REACT_PUBLIC_SANITY_TOKEN,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
